export const SPECIALBOXLOG_LIST_REQUEST = 'SPECIALBOXLOG_LIST_REQUEST';

export const SPECIALBOXLOG_LIST = 'SPECIALBOXLOG_LIST';

export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';

export const SET_SPECIALBOXLOG_PAGINATION = 'SET_SPECIALBOXLOG_PAGINATION';

export const SPECIALBOXLOG_PAGE_RESET = 'SPECIALBOXLOG_PAGE_RESET';
